"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_redux_1 = require("react-redux");
var Checkbox_1 = __importDefault(require("atomicComponents/atoms/Table/Checkbox"));
var StatusBadge_1 = __importDefault(require("atomicComponents/molecules/Badge/StatusBadge"));
var CheckboxCellWrapper_1 = __importDefault(require("containersRechargly/Recharges/Recharges/CellComponents/CheckboxCellWrapper"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var base_1 = require("utils/selectors/base");
var single_1 = require("utils/selectors/single");
var constants_1 = require("../constants");
var context_1 = require("../context");
var SimplifiedCheckboxInput = (0, SimplifyFormInput_1.default)(Checkbox_1.default);
var RechargerStatus = function (_a) {
    var item = _a.item;
    var _b = (0, context_1.useSelectedRecharges)(), toggleId = _b.toggleId, selectedIds = _b.selectedIds, selectedItems = _b.selectedItems;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var advMode = (0, react_redux_1.useSelector)(base_1.selectAdvancedMode);
    var isSelected = selectedIds.includes(item.id);
    var isSelectable = (!selectedItems.length || !selectedItems[0].isExcluded === !item.isExcluded)
        && !constants_1.NON_ACTIONABLE_STATES.includes(item.rechargerStatus);
    return ((0, jsx_runtime_1.jsxs)(StatusBadge_1.default, __assign({ mapper: constants_1.RECHARGER_STATUS_MAPPER, status: item.rechargerStatus, height: 64, position: "relative", overflow: "visible" }, { children: [isSelectable && ((0, jsx_runtime_1.jsx)(CheckboxCellWrapper_1.default, __assign({ color: "azzurro", className: (0, clsx_1.default)('highlightInput', selectedIds.length ? '' : 'showOnHover'), selected: isSelected, onClick: toggleId(item.id) }, { children: (0, jsx_runtime_1.jsx)(SimplifiedCheckboxInput, { value: isSelected }) }))), profile.isAdmin && advMode && (0, jsx_runtime_1.jsx)("div", __assign({ style: { position: 'absolute', top: 0, background: 'rgba(255,255,255,0.5)' } }, { children: item.id }))] })));
};
exports.default = RechargerStatus;
